import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useEffect, useState } from "react";

interface NumberInputProps {
    min?: number;
    max: number;
    step?: number;
    value: number;
    setValue: (n: number) => void;
}

function NumberInput({min = 0, max, step = 1, value, setValue}: NumberInputProps) {

    const [faulty, setFaulty] = useState(false);

    useEffect(() => {
        if (value > max || value < min) {
            setFaulty(true)
        } else {
            setFaulty(false)
        }
    }, [value, max, min])

    function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
        const newValue = Number(e.target.value);
        if (!isNaN(newValue) && newValue >= min && newValue <= max) {
            setValue(newValue);
        };
    }

    function handleBlur() {
        if (faulty) {
            if (value > max) {
                setValue(max)
            } else {
                setValue(min)
            }
        };
    }
    
    function handlePlusButtonClick() {
        if (value + step <= max) {
            setValue(value + step)
        } else {
            setValue(max)
        };
    }
    function handleMinusButtonClick() {
        if (value - step >= min) {
            setValue(value - step)
        } else {
            setValue(min)
        };
    }
    
    return (
        <div className={`number-input ${faulty ? 'faulty' : ''}`}>
            <input type="text" size={max.toString().length} value={value} onChange={(e) => handleInputChange(e)} onBlur={() => handleBlur()}/>
            <button className="plus" onClick={() => handlePlusButtonClick()}><KeyboardArrowUpIcon/></button>
            <button className="minus" onClick={() => handleMinusButtonClick()}><KeyboardArrowDownIcon/></button>
        </div>
    );
}

export default NumberInput;